export default "__VITE_ASSET__TZs1jhpL__"